const externalLinks = document.querySelectorAll('a[target="_blank"]');
const socialIcons = document.querySelectorAll('.wp-social-link a');

if (socialIcons) {
  [...socialIcons].forEach(socialLi => {
    socialLi.classList.add('u--disable-external-icon');
  });
}

if (externalLinks) {
  [...externalLinks].forEach(linkEl => {
    if (!linkEl.classList.contains('u--disable-external-icon')) {
      // Disable no-param-reassign as we're not reassiging the param, we're updating the DOM node.
      /* eslint-disable-next-line no-param-reassign */
      linkEl.innerHTML += `<span class="u-srText">External link:</span><i class="material-icons" aria-hidden="true">open_in_new</i>`;
    }
  });
}
